








































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {AugmentedLeg} from "./JourneySummary.vue";
import {CrsConverter} from "./CrsConverter";
import ModeIcon from "./ModeIcon.vue";
import {DateTime} from "luxon";
import { Stop, TrainRecord } from "./JourneyDetails";

@Component({
    components: {ModeIcon}
})
export default class LegSummary extends Vue {
    @Prop() journey: Array<AugmentedLeg>;
    @Prop() crsConverter: CrsConverter;
    @Prop() label: string;

    legsShowingFull: Array<number> = [];

    filteredStops(tr: TrainRecord): Array<Stop> {
      return tr.stops.filter(s => s.activity !== 'P');
    }

    private isShowingIntermediateStopsFor(leg: AugmentedLeg) {
        return this.legsShowingFull.includes(leg.legRecordID);
    }

    private hideIntermediates(leg: AugmentedLeg) {
        this.legsShowingFull = this.legsShowingFull.filter(l => leg.legRecordID !== l);
    }


    private indexToClassName(index: number, upperBound: number): string {
        if (index === 0) {
            return "line first";
        } else if (index === upperBound) {
            return "line last";
        }
        return "line peg";
    }

    private isIntermediate(index: number, upperBound: number): boolean {
        return !(index === 0 || index === upperBound);
    }

    private getTime(departTime: string, arriveTime: string): string {
        const dtDepart = DateTime.fromISO(departTime);
        const dtArrive = DateTime.fromISO(arriveTime);
        const isDepartTimeInvalid = dtDepart.year <= 1;
        return isDepartTimeInvalid ? dtArrive.toFormat('HH:mm') : dtDepart.toFormat('HH:mm');
    }


}
